<template>
  <div class="friend">
    <List
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      offset="600"
    >
      <div class="eve-friend" v-for="item in list" :key="item.id">
        <div class="friend-left">
          <img class="friend-head" :src="defaultImg" alt="">
          <p>{{item.realname || item.username}}</p>
        </div>
        <div class="friend-right">注册时间： {{item.create_time.substr(0, 10)}}</div>
      </div>
      <div class="backof" v-if="!list.length">还未有朋友注册，快去分享吧！</div>
    </List>
  </div>
</template>

<script>
import { shareFriend } from '@/api/api/wechat'
import { List } from 'vant'
export default {
  data() {
    return {
      defaultImg: require('@/assets/image/head.jpg'),
      finished: false,
      total: 0,
      page: 0,
      list: [],
      isloading: false
    };
  },
  components: {
    List
  },
  created() {
    this.getFri()
  },
  methods: {
    getFri() {
      this.page++
      shareFriend(this.page).then(res => {
        this.list = res.data.data.list
        setTimeout(() => {
          this.isloading = true
        },1000)
      })
    },
    onLoad() {
      if(!this.isloading) return
      if(this.total < 10) {
        this.nomore = true
        return
      }
      if((this.page *10) < this.total) {
        this.isloading = false
        this.getFri()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.friend {
  padding-top: 10px;
  padding-left: 20px;
  .backof {
    text-align: center;
    padding: 20px;
    color: #ccc;
    font-weight: 700;
    font-size: 16px;
  }
  .eve-friend {
    padding-right: 20px;
    display: flex;
    height: 60px;
    justify-content: space-between;
    font-size: 12px;
    align-items: center;
    color: #666;
    border-bottom: 1px solid #d8d8d8;
    .friend-left {
      display: flex;
      align-items: center;
      font-size: 16px;
      line-height: 60px;
      color: #333;
    }
    .friend-head {
      margin-right: 12px;
      width: 46px;
      height: 46px;
      border-radius: 50%;
    }
    .friend-right {
      padding-top: 20px;
    }
  }
}
</style>